import Config from 'app/config';
import apiFactory from './factory';

export const access = apiFactory(Config.get('ACAST_ACCESS_API_HOST'));
export const create = apiFactory(Config.get('CREATE_API_HOST'));
export const insights = apiFactory(Config.get('INSIGHTS_API_HOST'));
export const auth = apiFactory(Config.get('AUTH_HOST'));
export const roles = apiFactory(Config.get('ROLES_API_URL'));
export default create;
